import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification} from 'antd';

import {getSalon, updateSalon} from './actions';
import {bindActionCreators} from "redux";
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateSalonForm extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.salonId !== this.props.match.params.salonId) {
      this._load();
    }
  }

  _load = () => {
    const {salonId} = decodeParams(this.props.match.params);
    if (salonId) {
      this.props.getSalon({salonId});
    }
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {salonId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) return;
      this.props.updateSalon({...values, salonId})
        .then(this.goBack)
        .catch(err => notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        }));
    });
  };

  render() {
    const {salon, form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    const {name, address, phoneNumber, email} = salon;
    const [addressStreet, addressCity, addressState, addressCountry, addressPostalCode] = (address || '').split(', ');
    return (
      <Card title="Update Salon">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Street Address"
          >
            {getFieldDecorator('addressStreet', {initialValue: addressStreet})(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="City"
          >
            {getFieldDecorator('addressCity', {initialValue: addressCity})(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="State/Province"
          >
            {getFieldDecorator('addressState', {initialValue: addressState})(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Country"
          >
            {getFieldDecorator('addressCountry', {initialValue: addressCountry})(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Postal Code"
          >
            {getFieldDecorator('addressPostalCode', {initialValue: addressPostalCode})(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Phone"
          >
            {getFieldDecorator('phoneNumber', {
              initialValue: phoneNumber,
              rules: [
                {pattern: /^\d{3}\s\d{3}-\d{4}$/, message: 'phone number should be in the format: 555 555-5555'}
              ]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Email"
          >
            {getFieldDecorator('email', {
              initialValue: email,
              rules: [
                {pattern: /^[\w.]+@[\w.]+\.\w{2,}$/, message: 'email should be in the format: user@domain.ext'}
              ],
            })(
              <Input />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Salon
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

UpdateSalonForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  updateSalon: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  getSalon: PropTypes.func.isRequired,
  salon: PropTypes.object.isRequired,
};

const UpdateSalonPage = Form.create()(UpdateSalonForm);

const mapStateToProps = state => ({
  loading: state.salon.salonLoading || state.salon.updatingSalon,
  salon: state.salon.salon || {}
});

const mapDispatchToProps = dispatch => ({
  getSalon: payload => (dispatch(getSalon(payload))),
  updateSalon: bindActionCreators(updateSalon, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateSalonPage);



// WEBPACK FOOTER //
// ./src/Salon/UpdateSalonPage.js